import { generateAbsoluteUrl, generateArticleLink } from "../../helpers/linkGenerators";
export const getShareUrl = (_state, slug) => {
    return generateAbsoluteUrl(generateArticleLink(slug));
};
export * from "./common";
